import { Button, typography } from '@joor/design-system'
import { Progress } from 'semantic-ui-react'
import styled from 'styled-components'

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`

export const OptionButton = styled(Button)`
  width: 120px;
`

export const ProgressBar = styled(Progress)`
  width: 460px;
  align-self: center;
  border-radius: 5px !important;
  height: auto;
  overflow: visible;
  & > .label {
    ${typography.alpha.primaryActive.subtitle3};
    font-weight: 500 !important;
    font-style: normal !important;
    font-size: 14px !important;
    line-height: 16px !important;
    white-space: break-spaces;
    position: fixed;
    padding: 16px 0 0;
    height: fit-content;
  }
  & > .bar {
    background-color: var(--color-secondary-600) !important;
    border-radius: 5px !important;
  }
  & > .error {
    background-color: red !important;
  }
`

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 180px;
`

export const ErrorSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: var(--size-font-base);
  }
`
